import { relatorioService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const relatorioAction = {
    getComprovante,
    getRelatorio,
    getRelatorioById,
    onChangeProps,
    editRelatorioInfo,
    deleteRelatorioById,
    clear
};

function getComprovante(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'relatorios/';
        relatorioService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request != undefined && response.request.status == 200) {
                    var ret = JSON.parse(response.request.responseText);
                  //  console.log("ret", ret);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.html('<a href="' + ret.message +'" target="_blank"> Acessar Relatório</a>', '/relatorioFiltro'); //ret.Path
                } else {
                   // console.log("entrei no else")
                    alerts.warning(response.data);
                }
                //dispatch(createUserInfo());
                //history.push('/relatorios');
            })
    }
}

function getRelatorio(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'relatorios/';
        relatorioService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request != undefined && response.request.status == 200) {
                    var ret = JSON.parse(response.request.responseText);
                    //  console.log("ret", ret);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.html('<a href="' + ret.message + '" target="_blank"> Acessar Relatório</a>'); //ret.Path
                } else {
                    // console.log("entrei no else")
                    alerts.warning(response.data);
                }
                //dispatch(createUserInfo());
                //history.push('/relatorios');
            })
    }
}

function getRelatorioById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'relatorios/' + id;
        relatorioService.get(apiEndpoint)
            .then((response) => {
                dispatch(editRelatoriosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}

function editRelatorioInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'relatorios/' + id;
        relatorioService.put(apiEndpoint, payload)
            .then((response) => {
                if (response && response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/relatorioFiltro'); //ret.Path
                } else {
                    alerts.warning(response.data);
                }
                //dispatch(updatedUserInfo());
                //history.push('/relatorios');
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    }
}
function deleteRelatorioById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {                  
                    let apiEndpoint = 'relatorios/' + id;
                    relatorioService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteRelatoriosDetails());
                                if (showWaiting) {
                                    alerts.clean();
                                }
                                dispatch(relatorioAction.getRelatorio());                               
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })

                }
            });

        
    };
}
export function changeRelatoriosList(relatorio) {
    return {
        type: "FETECHED_ALL_RELATORIO",
        relatorio: relatorio
    }
}
export function clear() {
    return {
        type: "RELATORIO_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editRelatoriosDetails(relatorio) {
    return {
        type: "RELATORIO_DETAIL",
        id: relatorio.id,
        id_empresa: relatorio.id_empresa,
        id_inseminador: relatorio.id_inseminador,
        id_produtor: relatorio.id_produtor,
        inscricao_prefeitura: relatorio.inscricao_prefeitura,
        tipo_relatorio: relatorio.tipo_relatorio,
        data_inicio: relatorio.data_inicio,
        data_termino: relatorio.data_termino
    }
}
export function updatedUserInfo() {
    return {
        type: "RELATORIO_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "RELATORIO_CREATED_SUCCESSFULLY"
    }
}
export function deleteRelatoriosDetails() {
    return {
        type: "DELETED_RELATORIO_DETAILS"
    }
}